import { http } from "../../utils/config";

// Thông báo NSX (broadcast) — Loại B. Module Notification: /api/v1/notification/admin/notifications
const BASE = "/api/v1/notification/admin/notifications";

const manufacturerNotificationApi = {
  // Soạn & gửi
  create: (payload) => http.post(BASE, payload).then((r) => r.data),
  // Danh sách đã gửi (paginate)
  getList: (params) => http.get(BASE, { params }).then((r) => r.data),
  getDetail: (id) => http.get(`${BASE}/${id}`).then((r) => r.data),
  remove: (id) => http.delete(`${BASE}/${id}`).then((r) => r.data),

  // Nguồn dữ liệu cho bộ chọn đối tượng gửi (tái dùng endpoint có sẵn)
  getMembershipClasses: () =>
    http.get("/mcoupon/api/v1/membership-class-cms").then((r) => r.data),
  searchCustomers: (search) =>
    http
      .get("/mcoupon/api/v1/customer/getList", {
        params: { has_paginate: 1, size: 50, search },
      })
      .then((r) => r.data),
};

export default manufacturerNotificationApi;
